<script lang="ts">
    
    import { createEventDispatcher } from "svelte";
    import type { Form } from "../Model/Form";

    export let form: Form;

    const dispatch = createEventDispatcher();

    function onClick(): void {
        dispatch('click', form);
    }

</script>

<style lang="scss">

    @use '../variables';

    .form {
        display: flex;
        align-items: flex-start;
        gap: 1rem;
        padding: 1rem 0;
        border-top: 1px solid #ddd;

        &:first-child {
            margin-top: 0;
            border-top: none;
        }
    }

    .image {
        position: relative;
        flex-shrink: 0;
        width: 90px;
        background-color: variables.$color-neutral;
        border-radius: 1rem;

        &::before {
            content: '';
            display: block;
            padding-top: 100%;
        }
    }

    .icon {
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
    }

    .name {
        font-size: 1.1em;
        font-weight: bold;
    }

    .description {
        font-size: 0.8em;
    }

</style>

<div class="form" on:click={onClick}>
    <div class="image">
        <img class="icon" src="/images/icon-plus-square.svg" alt="">
    </div>
    <div class="meta">
        <div class="name">{form.name}</div>
        <div class="description">{form.description}</div>
    </div>
</div>